import React, { useState } from 'react';
import { Search, Filter, Globe, Award, TrendingUp, Package } from 'lucide-react';

const MaquilaDashboard = () => {
  const [filtroTipo, setFiltroTipo] = useState('Todos');
  const [busqueda, setBusqueda] = useState('');
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);

  const productos = [
    {
      id: 17,
      nombre: "Catsup",
      tipo: "Próximamente",
      empresas: ["Próximamente"],
      mercados: ["Nacional"],
      presentaciones: ["Por definir"],
      descripcion: "Catsup de tomate premium. Nueva línea de salsas y condimentos en desarrollo para ampliar nuestro portafolio de maquila."
    },
    {
      id: 18,
      nombre: "Mayonesa",
      tipo: "Próximamente",
      empresas: ["Próximamente"],
      mercados: ["Nacional"],
      presentaciones: ["Por definir"],
      descripcion: "Mayonesa cremosa de alta calidad. Producto en desarrollo para expandir nuestros servicios de maquila a nuevas categorías."
    },
    {
      id: 1,
      nombre: "Frijol Bayo Refrito",
      tipo: "Refrito",
    //  empresas: ["Walmart", "3B", "Bara", "Chedraui", "Soriana", "Pueblo Rico"],
      mercados: ["Nacional"],
      presentaciones: ["Bolsa 400g", "Bolsa 560g", "Bolsa 820g"],
      descripcion: "Frijol bayo procesado y refrito, listo para consumir. Producto estrella en el mercado nacional.",
      // capacidadProduccion: "15,000 bolsas/día",
      // certificaciones: ["HACCP", "SQF", "Kosher"],
      // imagen: "🫘"
    },
    {
      id: 2,
      nombre: "Frijol Negro Refrito",
      tipo: "Refrito",
    //  empresas: ["Walmart", "3B", "Bara", "Chedraui", "Soriana", "Pueblo Rico"],
      mercados: ["Nacional"],
      presentaciones: ["Bolsa 400g", "Bolsa 560g", "Bolsa 820g"],
      descripcion: "Frijol negro refrito con el sabor tradicional mexicano. Alta demanda en cadenas comerciales.",
      // capacidadProduccion: "12,000 bolsas/día",
      // certificaciones: ["HACCP", "SQF", "Kosher"],
      // imagen: "🖤"
    },
    {
      id: 3,
      nombre: "Frijol Peruano Refrito",
      tipo: "Refrito",
   //   empresas: ["Walmart", "3B", "Bara", "Chedraui", "Soriana", "Pueblo Rico"],
      mercados: ["Nacional"],
      presentaciones: ["Bolsa 400g", "Bolsa 560g", "Bolsa 820g"],
      descripcion: "Frijol peruano refrito con textura cremosa y sabor distintivo. Preferido por consumidores exigentes.",
    },
    {
      id: 6,
      nombre: "Frijol Pinto",
      tipo: "Entero",
   //   empresas: ["Producción Propia", "Walmart", "Chedraui", "3B", "Neto", "Aurrera", "Bara"],
      mercados: ["Nacional y Internacional"],
      presentaciones: ["Bolsa 900g"],
      descripcion: "Nueva línea de frijol entero para el mercado nacional. Próximamente disponible.",
    },
        {
      id: 7,
      nombre: "Frijol Negro",
      tipo: "Entero",
  //    empresas: ["Producción Propia", "Walmart", "Chedraui", "3B", "Neto", "Aurrera"  , "Bara"],
      mercados:["Nacional y Internacional"],
      presentaciones: ["Bolsa 900g"],
      descripcion: "Nueva línea de frijol entero para el mercado nacional. Próximamente disponible.",
    },
        {
      id: 8,
      nombre: "Frijol Flor de Mayo",
      tipo: "Entero",
  //    empresas: ["Producción Propia", "Walmart", "Chedraui", "3B", "Neto", "Aurrera", "Bara"],
      mercados: ["Nacional y Internacional"],
      presentaciones: ["Bolsa 900g"],
      descripcion: "Nueva línea de frijol entero para el mercado nacional. Próximamente disponible.",
    },
    {
      id: 9,
      nombre: "Frijol Peruano",
      tipo: "Entero",
   //   empresas: ["Producción Propia", "Walmart", "Chedraui", "3B", "Neto", "Aurrera", "Bara"],
      mercados: ["Nacional y Internacional"],
      presentaciones: ["Bolsa 900g"],
      descripcion: "Nueva línea de frijol entero para el mercado nacional. Próximamente disponible.",
    },
    {
      id: 10,
      nombre: "Frijol Bayo",
      tipo: "Entero",
   //   empresas: ["Producción Propia", "Walmart", "Chedraui", "3B", "Neto", "Aurrera", "Bara"],
      mercados: ["Nacional y Internacional"],
      presentaciones: ["Bolsa 900g"],
      descripcion: "Nueva línea de frijol entero para el mercado nacional. Próximamente disponible.",
    },
    {
      id: 11,
      nombre: "Jamaica",
      tipo: "Productos Naturales",
   //   empresas: ["Producción Propia"],
      mercados: ["Nacional y Internacional"],
      presentaciones: ["Bolsa 1kg"],
      descripcion: "Flor de jamaica deshidratada de alta calidad. Producto natural con propiedades antioxidantes y sabor distintivo."
    },
    {
      id: 12,
      nombre: "Maíz Palomero",
      tipo: "Cereales",
   //   empresas: ["Producción Propia", "Walmart", "Aurrera", "Neto", "Chedraui"],
      mercados: ["Nacional"],
      presentaciones: ["Bolsa 500g"],
      descripcion: "Maíz palomero premium para elaboración de palomitas. Grano seleccionado con alta capacidad de expansión."
    },
    {
      id: 13,
      nombre: "Garbanzo",
      tipo: "Leguminosas",
      // empresas: ["Producción Propia", "Bara"],
      mercados: ["Nacional y Internacional"],
      presentaciones: ["Bolsa 500g", "Bolsa 1kg", "Granel"],
      descripcion: "Garbanzo de primera calidad, rico en proteínas y fibra. Ideal para preparaciones culinarias tradicionales y modernas."
    },
    {
      id: 14,
      nombre: "Lentejas",
      tipo: "Leguminosas",
      // empresas: ["Producción Propia", "Chedraui", "3B", "Neto", "Bara"],
      mercados: ["Nacional y Internacional"],
      presentaciones: ["Bolsa 500g", "Bolsa 250g"],
      descripcion: "Lentejas premium, fuente excepcional de proteína vegetal. Producto versátil para múltiples aplicaciones culinarias."
    },
    {
      id: 15,
      nombre: "Alpiste",
      tipo: "Semillas",
      // empresas: ["Chedraui"],
      mercados: ["Nacional"],
      presentaciones: ["Bolsa 1kg"],
      descripcion: "Alpiste de grado alimentario, procesado bajo estrictos controles de calidad. Rico en nutrientes y antioxidantes naturales."
    },
    {
      id: 16, 
      nombre: "Avena",
      tipo: "Cereales",
      // empresas: ["Producción Propia", "Chedraui", "3B", "Neto",  ],
      mercados: ["Nacional y Internacional"],
      presentaciones: ["Bolsa 500g", "Bolsa 250g"],
      descripcion: "Avena de alta calidad, ideal para desayunos saludables y productos de panadería. Rica en fibra y nutrientes esenciales."
    }

  ];

  const tipos = ['Todos', 'Refrito', 'Entero', 'Leguminosas', 'Cereales', 'Semillas', 'Productos Naturales', 'Próximamente'];

  const productosFiltrados = productos.filter(producto => {
    const coincideTipo = filtroTipo === 'Todos' || producto.tipo === filtroTipo;
    const coincideBusqueda = producto.nombre.toLowerCase().includes(busqueda.toLowerCase()) ||
                           producto.mercados.some(mercado => mercado.toLowerCase().includes(busqueda.toLowerCase()));
    return coincideTipo && coincideBusqueda;
  });

  const getTipoColor = (tipo) => {
    const colores = {
      'Refrito': 'bg-orange-100 text-orange-800',
      'Entero': 'bg-green-100 text-green-800',
      'Leguminosas': 'bg-purple-100 text-purple-800',
      'Cereales': 'bg-yellow-100 text-yellow-800',
      'Semillas': 'bg-blue-100 text-blue-800',
      'Productos Naturales': 'bg-pink-100 text-pink-800',
      'Próximamente': 'bg-gradient-to-r from-green-100 via-emerald-100 to-teal-100 text-green-700 border border-green-200 shadow-md animate-pulse'
    };
    return colores[tipo] || 'bg-gray-100 text-gray-800';
  };

  const handleSeleccionarProducto = (id) => {
    setProductoSeleccionado(id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (productoSeleccionado) {
    const producto = productos.find(p => p.id === productoSeleccionado);
    const indiceActual = productos.findIndex(p => p.id === productoSeleccionado);
    const productoAnterior = indiceActual > 0 ? productos[indiceActual - 1] : null;
    const productoSiguiente = indiceActual < productos.length - 1 ? productos[indiceActual + 1] : null;

    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-100">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-start items-center mb-6">
            <button 
              onClick={() => setProductoSeleccionado(null)}
              className="flex items-center gap-2 px-5 py-2 rounded-full bg-gradient-to-r from-orange-400 to-red-400 text-white font-semibold shadow-lg hover:from-orange-500 hover:to-red-500 hover:scale-105 transition-all border-2 border-white focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              ← Volver
            </button>
          </div>
          
          <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden">
            <div className={`${
              producto.tipo === 'Próximamente' 
                ? 'bg-gradient-to-r from-emerald-600 via-teal-600 to-cyan-600 text-white p-8 relative overflow-hidden' 
                : 'bg-gradient-to-r from-orange-600 to-red-600 text-white p-8'
            }`}>
              {producto.tipo === 'Próximamente' && (
                <div className="absolute top-0 right-0 bg-gradient-to-l from-yellow-400 to-orange-400 text-gray-800 px-6 py-2 text-sm font-bold transform rotate-12 translate-x-6 -translate-y-2 shadow-lg">
                  ¡PRÓXIMAMENTE!
                </div>
              )}
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-4">
                  <div>
                    <h1 className="text-3xl font-bold mb-2">{producto.nombre}</h1>
                    <div className="flex items-center gap-4 text-orange-100 mb-2">
                      {producto.capacidadProduccion && (
                        <span className="flex items-center gap-1">
                          <Package className="w-4 h-4" />
                          {producto.capacidadProduccion}
                        </span>
                      )}
                      <span className="flex items-center gap-1">
                        <Globe className="w-4 h-4" />
                        {producto.mercados.join(', ')}
                      </span>
                    </div>
                    <div className="flex items-center gap-2 mb-4">
                      <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                        producto.tipo === 'Próximamente' 
                          ? 'bg-yellow-400 text-gray-800 font-bold shadow-lg animate-pulse' 
                          : getTipoColor(producto.tipo)
                      }`}>
                        {producto.tipo}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-8">
              <div className="grid lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 space-y-6">
                  <div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-3">Descripción del Producto</h2>
                    <p className="text-gray-600 leading-relaxed">{producto.descripcion}</p>
                  </div>

                  {/* Sección de empresas eliminada */}

                  {/* Certificaciones solo si existen */}
                  {Array.isArray(producto.certificaciones) && producto.certificaciones.length > 0 && (
                    <div>
                      <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
                        <Award className="w-6 h-6 text-orange-600" />
                        Certificaciones
                      </h2>
                      <div className="flex flex-wrap gap-2">
                        {producto.certificaciones.map((cert, index) => (
                          <span key={index} className="px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-medium">
                            {cert}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  <div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-4">Presentaciones Disponibles</h2>
                    <div className="flex flex-wrap gap-3">
                      {producto.presentaciones.map((presentacion, index) => (
                        <span key={index} className="px-4 py-2 bg-blue-100 text-blue-800 rounded-lg font-medium">
                          {presentacion}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  {producto.capacidadProduccion && (
                    <div className="bg-gradient-to-br from-orange-50 to-red-50 p-6 rounded-xl">
                      <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                        <TrendingUp className="w-5 h-5 text-orange-600" />
                        Capacidad de Producción
                      </h3>
                      <p className="text-2xl font-bold text-orange-600">{producto.capacidadProduccion}</p>
                    </div>
                  )}

                  <div className="bg-white border border-gray-200 p-6 rounded-xl">
                    <h3 className="text-lg font-bold text-gray-800 mb-4">Mercados Objetivo</h3>
                    <div className="space-y-3">
                      {producto.mercados.map((mercado, index) => (
                        <div key={index} className="flex items-center gap-3">
                          <Globe className="w-5 h-5 text-gray-500" />
                          <span className="text-gray-700">{mercado}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bg-green-50 p-6 rounded-xl">
                    <h3 className="text-lg font-bold text-gray-800 mb-2">Estado de Producción</h3>
                    <span className="inline-flex items-center gap-2 text-green-800">
                      <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                      {producto.tipo === 'Próximamente' ? 'En Desarrollo' : 'Activo'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Navegación entre productos - Movida aquí */}
          {(productoAnterior || productoSiguiente) && (
            <div className="max-w-6xl mx-auto mt-6">
              <div className="bg-white rounded-xl shadow-lg p-4 border border-gray-200">
                <div className="flex justify-between items-center">
                  <div className="flex-1">
                    {productoAnterior && (
                      <button
                        onClick={() => {
                          setProductoSeleccionado(productoAnterior.id);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-all"
                      >
                        ← {productoAnterior.nombre}
                      </button>
                    )}
                  </div>
                  
                  <div className="flex-1 text-center">
                    <span className="text-sm text-gray-500">
                      Producto {indiceActual + 1} de {productos.length}
                    </span>
                  </div>
                  
                  <div className="flex-1 text-right">
                    {productoSiguiente && (
                      <button
                        onClick={() => {
                          setProductoSeleccionado(productoSiguiente.id);
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        className="flex items-center gap-2 px-4 py-2 rounded-lg bg-gray-100 text-gray-700 font-medium hover:bg-gray-200 transition-all ml-auto"
                      >
                        {productoSiguiente.nombre} →
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-100">
      <div className="container mx-auto px-4 py-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
             Servicios de Maquila Especializada
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Servicios de maquila en alimentos procesados: frijoles refritos, enteros, cocidos y procesamiento especializado de leguminosas y cereales para marcas líderes nacionales e internacionales.
          </p>
        </div>
        
        {/* <div className="max-w-6xl mx-auto mb-8 flex flex-col items-center">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 w-auto">
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">Marcas Atendidas</p>
                  <p className="text-2xl font-bold text-green-600">12+</p>
                </div>
                <Building2 className="w-8 h-8 text-green-600" />
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">Mercados</p>
                  <p className="text-2xl font-bold text-blue-600">3</p>
                </div>
                <Globe className="w-8 h-8 text-blue-600" />
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600">Tipos de Producto</p>
                  <p className="text-2xl font-bold text-purple-600">2</p>
                </div>
                <Award className="w-8 h-8 text-purple-600" />
              </div>
            </div>
          </div>
        </div> */}

        <div className="max-w-6xl mx-auto mb-8">
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <div className="flex flex-col md:flex-row gap-4 items-center">
              <div className="relative flex-1">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Buscar productos por nombre, marca o mercado..."
                  value={busqueda}
                  onChange={(e) => setBusqueda(e.target.value)}
                  className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                />
              </div>
              <div className="flex items-center gap-2">
                <Filter className="text-gray-500 w-5 h-5" />
                <select
                  value={filtroTipo}
                  onChange={(e) => setFiltroTipo(e.target.value)}
                  className="px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  {tipos.map(tipo => (
                    <option key={tipo} value={tipo}>{tipo}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* Sección especial para productos Próximamente */}
          {productosFiltrados.some(producto => producto.tipo === 'Próximamente') && (
            <div className="mb-12">
              <div className="text-center mb-8">
                <h2 className="text-3xl font-bold bg-gradient-to-r from-green-600 via-emerald-600 to-teal-600 bg-clip-text text-transparent mb-4">
                  🚀 Próximos Lanzamientos
                </h2>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                  Nuevos productos en desarrollo que ampliarán nuestro portafolio de servicios de maquila
                </p>
              </div>
              
              <div className="flex justify-center">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 max-w-4xl">
                  {productosFiltrados.filter(producto => producto.tipo === 'Próximamente').map(producto => (
                    <div
                      key={producto.id}
                      onClick={() => handleSeleccionarProducto(producto.id)}
                      className="bg-gradient-to-br from-green-50 via-emerald-50 to-teal-50 border-2 border-green-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-500 cursor-pointer relative overflow-hidden animate-pulse rounded-2xl group"
                    >
                    <div className="absolute top-0 right-0 bg-gradient-to-l from-green-500 to-emerald-500 text-white px-3 py-1 text-xs font-bold transform rotate-12 translate-x-4 -translate-y-1 shadow-lg">
                      ¡NUEVO!
                    </div>
                    
                    {/* Header mejorado */}
                    <div className="bg-gradient-to-r from-green-100 to-emerald-100 p-4 border-b border-green-200">
                      <div className="flex items-center justify-between mb-3">
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${getTipoColor(producto.tipo)} shadow-sm`}>
                          {producto.tipo}
                        </span>
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-yellow-500 rounded-full animate-pulse"></div>
                          <span className="text-xs text-yellow-600 font-semibold">En Desarrollo</span>
                        </div>
                      </div>
                      <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-green-700 transition-colors">{producto.nombre}</h3>
                      
                      {/* Badges informativos */}
                      <div className="flex flex-wrap gap-2 mb-3">
                        <span className="px-2 py-1 bg-green-200 text-green-800 rounded-full text-xs font-medium flex items-center gap-1">
                          <Globe className="w-3 h-3" />
                          Mercados: {producto.mercados.join(', ')}
                        </span>
                      </div>
                    </div>

                    <div className="p-6">

                      {/* Descripción mejorada */}
                      <div className="mb-4 p-3 bg-white/70 rounded-lg border border-gray-200">
                        <p className="text-sm text-gray-700 leading-relaxed line-clamp-3">
                          {producto.descripcion}
                        </p>
                      </div>

                      {/* Presentaciones con estilo especial */}
                      <div className="mb-4">
                        <p className="text-xs font-semibold text-gray-600 mb-2 flex items-center gap-1">
                          <Package className="w-3 h-3" />
                          Presentaciones Proyectadas
                        </p>
                        <div className="flex flex-wrap gap-2">
                          {producto.presentaciones.map((presentacion, index) => (
                            <span key={index} className="px-3 py-1 bg-gradient-to-r from-green-100 to-emerald-100 text-green-700 rounded-lg text-xs font-medium border border-green-300">
                              {presentacion}
                            </span>
                          ))}
                        </div>
                      </div>

                      {/* Footer especial para próximamente */}
                      <div className="pt-4 border-t border-green-200">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                            <span className="text-xs text-green-600 font-medium">Próximo Lanzamiento</span>
                          </div>
                          <div className="w-6 h-6 bg-green-200 rounded-full flex items-center justify-center group-hover:bg-green-300 transition-colors">
                            <span className="text-green-700 text-sm font-bold">→</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                </div>
              </div>
              
              {/* Línea separadora con gradiente */}
              <div className="relative mb-12">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full h-px bg-gradient-to-r from-green-300 via-emerald-300 to-teal-300"></div>
                </div>
                <div className="relative flex justify-center text-lg">
                  <span className="bg-white px-6 py-2 text-gray-500 font-medium rounded-full shadow-lg">
                    Catálogo de Productos Activos
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Productos regulares */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {productosFiltrados.filter(producto => producto.tipo !== 'Próximamente').map(producto => (
              <div
                key={producto.id}
                onClick={() => handleSeleccionarProducto(producto.id)}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 cursor-pointer group"
              >
                {/* Header con gradiente sutil */}
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-4 border-b border-gray-200">
                  <div className="flex items-center justify-between mb-2">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${getTipoColor(producto.tipo)}`}>
                      {producto.tipo}
                    </span>
                    <div className="flex items-center gap-1">
                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                      <span className="text-xs text-green-600 font-medium">Activo</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 group-hover:text-orange-600 transition-colors">{producto.nombre}</h3>
                </div>

                <div className="p-6">
                  {/* Info principal */}
                  <div className="space-y-3 mb-4">
                    <div className="flex items-center gap-2 text-sm text-gray-600">
                      <Globe className="w-4 h-4 text-blue-500" />
                      <span className="font-medium">Mercados:</span>
                      {producto.mercados.join(', ')}
                    </div>
                    
                    {/* <div className="flex items-center gap-2 text-sm text-gray-600">
                      <Building2 className="w-4 h-4 text-purple-500" />
                      <span className="font-medium">Clientes:</span>
                      {producto.empresas.length} empresas
                    </div> */}

                    {producto.capacidadProduccion && (
                      <div className="flex items-center gap-2 text-sm text-gray-600">
                        <TrendingUp className="w-4 h-4 text-green-500" />
                        <span className="font-medium">Capacidad:</span>
                        {producto.capacidadProduccion}
                      </div>
                    )}
                  </div>

                  {/* Descripción */}
                  <div className="mb-4 p-3 bg-gray-50 rounded-lg">
                    <p className="text-sm text-gray-600 line-clamp-2">
                      {producto.descripcion}
                    </p>
                  </div>

                  {/* Presentaciones */}
                  <div className="mb-4">
                    <p className="text-xs font-semibold text-gray-500 mb-2"></p>
                    <div className="flex flex-wrap gap-1">
                      {producto.presentaciones.slice(0, 3).map((presentacion, index) => (
                        <span key={index} className="px-2 py-1 bg-orange-100 text-orange-700 rounded text-xs font-medium">
                          {presentacion}
                        </span>
                      ))}
                      {producto.presentaciones.length > 3 && (
                        <span className="px-2 py-1 bg-gray-200 text-gray-600 rounded text-xs">
                          +{producto.presentaciones.length - 3} más
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Footer con call to action */}
                  <div className="pt-3 border-t border-gray-100">
                    <div className="flex items-center justify-between">
                      <span className="text-xs text-gray-500">Ver detalles completos</span>
                      <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center group-hover:bg-orange-200 transition-colors">
                        <span className="text-orange-600 text-sm">→</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {productosFiltrados.length === 0 && (
            <div className="text-center py-12">
              <div className="text-6xl mb-4">🔍</div>
              <p className="text-xl text-gray-600">No se encontraron productos</p>
              <p className="text-gray-500">Intenta con otros términos de búsqueda o filtros</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MaquilaDashboard;